import * as Sentry from '@sentry/browser';
import React, {Component} from 'react';
import {WhiteScreenFallback} from './WhiteScreenFallback';

export class WhiteScreenHandler extends Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError(error: any) {
    return {hasError: true};
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.debug(errorInfo);

    Sentry.withScope(scope => {
      scope.setTag('WSOD_captured', 'true');

      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.hasError) {
      return <WhiteScreenFallback
        onClose={() => {
          this.setState({hasError: false});
        }}
      />;
    }

    return this.props.children;
  }
}
